export const adminRoles = ['admin'];
export const clientRoles = ['user','billing'];
